/**
 * What a tenant hostname says to anybody who is not expected.
 *
 * This exact page is what an **unclaimed** address answers too, and that
 * uniformity is the point: if an unknown workspace 404'd and a real one rendered
 * something else, the wildcard would become a way to enumerate every customer.
 *
 * It is also what a candidate sees when a link is unknown, expired, already
 * used, or purged — all four are indistinguishable by design, so the difference
 * cannot become an oracle for guessing valid links.
 */
export default function DeadEnd({
  title = 'Nothing to see here',
  detail,
}: {
  title?: string;
  detail?: string;
}) {
  return (
    <main className="flex min-h-screen items-center justify-center px-6 py-20">
      <div className="w-full max-w-md text-center">
        <div
          aria-hidden
          className="mx-auto mb-7 h-px w-24 bg-gradient-to-r from-transparent via-veil/20 to-transparent"
        />
        <h1 className="text-lg font-medium text-ink/85">{title}</h1>
        <p className="mt-3 text-sm leading-relaxed text-ink/45">
          {detail ??
            'This link is not available. If somebody sent it to you, ask them to check it — a link works once, and expires.'}
        </p>
        <div
          aria-hidden
          className="mx-auto mt-7 h-px w-24 bg-gradient-to-r from-transparent via-veil/20 to-transparent"
        />
      </div>
    </main>
  );
}
